module.exports = __webpack_public_path__ + "static/media/coach_user_types.9f1c12f8.png";